import { Box, Button, Icon, Text } from '@fairfashion/design-system'
import { useTheme } from 'styled-components'

import { PendingItemCardProps } from './pending-invoice-card.types'

export const PendingItemCard = ({ item, onClick }: PendingItemCardProps) => {
  const theme = useTheme()

  return (
    <Box
      direction="column"
      backgroundColor="white"
      borderRadius={theme.border_radius.card}
      boxShadow={theme.box_shadow.card}
      gap={3}
      padding={3}
      width="100%"
    >
      <Box justifyContent="space-between" width="100%">
        <Box gap={1}>
          <Text size="small" color="grey_3">
            Item
          </Text>
          <Text size="small" color="grey_3">
            {item.code}
          </Text>
        </Box>
        <Text size="small" color="grey_3">
          {item.createdAt ? new Date(item.createdAt).toLocaleDateString() : ''}
        </Text>
      </Box>
      <Text>{item.client.name}</Text>

      <Box width="100%" gap={2} alignItems="flex-end">
        <Box flex={1}>
          <Box gap={1} width="100%">
            <Text color="grey_3" size="small">
              NF
            </Text>
            <Text size="small" color="grey_3">
              {' '}
              {item.invoice.code}
            </Text>
          </Box>
        </Box>
        <Box flex={1}>
          <Button width="100%" onClick={onClick}>
            <Icon name="add" color="white" size={20} />
            Cadastrar
          </Button>
        </Box>
      </Box>
    </Box>
  )
}
